import { gql, useQuery } from '@apollo/client';
import { useFetch } from '../../../utils/useFetch';
import {
  BrandKey,
  GetSourceQuery,
  GetSourceCountQuery,
  GetSourceCountQueryVariables,
  GetSourcesQuery,
  GetSourcesQueryVariables,
  GetSourceQueryVariables,
  SourceOrderingInput,
} from '../../../__generated__/queries-web';

const GET_SOURCES = gql`
  query GetSources(
    $first: UnsignedInt!
    $where: SourceFilterInput
    $orderBy: [SourceOrderingInput!]
  ) {
    sources(first: $first, where: $where, orderBy: $orderBy) {
      id
      title
      brandKey
      status
    }
  }
`;

export const useGetSources = (brand: BrandKey | null, skip?: boolean) =>
  useQuery<GetSourcesQuery, GetSourcesQueryVariables>(GET_SOURCES, {
    variables: {
      orderBy: [SourceOrderingInput.title_ASC],
      first: 100,
      where: {
        brandKey: brand,
      },
    },
    skip,
  });

export const useSourcesGetter = () =>
  useFetch<GetSourcesQuery, GetSourcesQueryVariables>(GET_SOURCES);

const GET_SOURCE = gql`
  query GetSource($where: SourceUniqueFilterInput!) {
    source(where: $where) {
      id
      title
    }
  }
`;

export const useSourceGetter = () =>
  useFetch<GetSourceQuery, GetSourceQueryVariables>(GET_SOURCE);

const GET_SOURCE_COUNT = gql`
  query GetSourceCount($where: SourceFilterInput) {
    sourceCount(where: $where)
  }
`;

export const useGetSourceCount = (
  variables: GetSourceCountQueryVariables,
  skip?: boolean,
) =>
  useQuery<GetSourceCountQuery, GetSourceCountQueryVariables>(
    GET_SOURCE_COUNT,
    {
      variables,
      skip,
    },
  );
